export enum CategoryKeys {
    default = 'default',
    default_lsd = 'default_lsd',
    eat_in = 'eat_in',
    bless_up = 'bless_up',
    wear_it = 'wear_it',
    made_in = 'made_in',
    out_in = 'out_in',
    schooled = 'schooled',
    industrious = 'industrious'
};